import { useEffect, useRef } from 'react';

// Настройка autocomplete для инпута, инпут из ui не позволяет менять autocomplete через пропсы
export const useInputAutocomplete = (autoComplete?: string) => {
    const inputRef = useRef<HTMLLabelElement>(null);
    useEffect(() => {
        if (autoComplete) {
            const inputWrapper = inputRef.current;
            const input = inputWrapper?.querySelector('input');
            input?.setAttribute('autocomplete', autoComplete);
        }
    }, []);
    return inputRef;
};
